/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".comment-box[_ngcontent-%COMP%]{background-color:#f5f5f5;border:1px solid #d0d0d0;border-radius:4px;padding:12px 16px;min-width:300px;word-break:break-word}.btn-msg[_ngcontent-%COMP%]{background-color:#1f2c5b;color:#fff;border:#1f2c5b}"];
export { styles as styles };
